import React, { useEffect } from "react";
import { Input, SelectPicker } from "rsuite";
import Responsive from "../../Components/Responsive";
import { cities } from "../../data/dataHotels";

const AddEdit = ({ model, _setmodel }) => {
  useEffect(() => console.log(model), []);
  return (
    <div>
      <Responsive className="p-10">
        <label htmlFor="">Nom : </label>
        <Input
          value={model.name}
          onChange={(name) => _setmodel((prev) => ({ ...prev, name }))}
        />
      </Responsive>
      <Responsive className="p-10" style={{ textAlign: "right" }}>
        <label htmlFor=""> : الاسم </label>
        <Input
          value={model.name_ar}
          onChange={(name_ar) => _setmodel((prev) => ({ ...prev, name_ar }))}
        />
      </Responsive>
      <Responsive className="p-10" style={{ textAlign: "right" }}>
        <label htmlFor="">: المدينة</label>
        <SelectPicker
          block
          searchable={false}
          data={cities}
          value={model.isMakkah}
          onChange={(isMakkah) => _setmodel((prev) => ({ ...prev, isMakkah }))}
        />
      </Responsive>
    </div>
  );
};

export default AddEdit;
